module.exports = __webpack_public_path__ + "9296cf45370c1ea87e01e3f279c150c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/wisdomtree.png
// module id = 1957
// module chunks = 0